import { Card } from "@ui/Card";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import "@ui/Button.css";
import "./NewQuestionDiscoveryCard.css";

const DISCOVERY_HREF = "/discovery";

export const NewQuestionDiscoveryCard = () => {
	return (
		<Card
			as="a"
			href={DISCOVERY_HREF}
			class="new-question-discovery-card"
			style={{ width: "100%" }}
			aria-label="Not sure who to ask? Go to Discovery"
		>
			<HStack
				align="center"
				spacing="large"
				justify="space-between"
				class="new-question-discovery-card__row"
			>
				<HStack
					align="center"
					spacing="large"
					class="new-question-discovery-card__lead"
				>
					<span class="new-question-discovery-card__icon" aria-hidden="true">
						<MaterialSymbol
							symbol="explore"
							color="primary"
							relativeSize={1.35}
						/>
					</span>
					<VStack spacing="small" align="start">
						<Text as="h2" size="intermediate" weight="bold" color="ink">
							Not sure who to ask?
						</Text>
						<Text size="standard" color="fg3">
							Browse creators and categories in Discovery
						</Text>
					</VStack>
				</HStack>
				<span
					class="gvtui-button gvtui-button--large secondary new-question-discovery-card__cta"
					aria-hidden="true"
				>
					<div>
						<span class="gvtui-button-link__content">Go to Discovery</span>
						<MaterialSymbol symbol="arrow_forward" relativeSize={1.14} />
					</div>
				</span>
			</HStack>
		</Card>
	);
};
